import PropTypes from 'prop-types';

const WalletCoinIcon = ({ className = '' }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <mask
      id="mask0_4784_4810"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <path
        d="M72 0H8C3.58172 0 0 3.58172 0 8V72C0 76.4183 3.58172 80 8 80H72C76.4183 80 80 76.4183 80 72V8C80 3.58172 76.4183 0 72 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4784_4810)">
      <path
        d="M72 0H8C3.58172 0 0 3.58172 0 8V72C0 76.4183 3.58172 80 8 80H72C76.4183 80 80 76.4183 80 72V8C80 3.58172 76.4183 0 72 0Z"
        fill="#F4EFED"
      />
      <rect x="16" y="40" width="64" height="40" fill="#FB6E44" />
      <path d="M16 40L0 80H32L16 40Z" fill="white" />
      <rect x="32" y="45.834" width="48" height="11.5" fill="white" />
      <path
        d="M69.7533 44.131C67.5583 38.6837 62.232 34.833 55.9988 34.833C49.7657 34.833 44.4379 38.6822 42.2444 44.131C41.5558 45.8419 41.167 47.7071 41.167 49.6643C41.167 52.4748 41.9639 55.0938 43.3219 57.333H68.6788C70.0367 55.0938 70.8337 52.4748 70.8337 49.6643C70.8337 47.7071 70.4448 45.8419 69.7562 44.131H69.7533Z"
        fill="#0A0777"
      />
    </g>
  </svg>
);

WalletCoinIcon.propTypes = {
  className: PropTypes.string
};

export default WalletCoinIcon;
